// Module
var code = `<main class="flex flex-col flex-grow gap-4 p-page"> <dx-button (onClick)="this.clearCache()" text="Clear Cache" stylingMode="outlined"> </dx-button> </main> `;
// Exports
export default code;